import { Component, OnInit, TemplateRef, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { SignaturePadComponent as LibSignaturePadComponent } from '@almothafar/angular-signature-pad';
import { PdfMakeWrapper } from 'pdfmake-wrapper';

// Tier 8: Wijmo imports removed (CellMaker / CollectionView / wijmo / wjcGrid /
// wjcInput / wjcGridXlsx). AG Grid via KiteGridComponent is the rendering engine.
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { WorkReqSelModel } from 'src/app/models/selects/workreq.sel.model';
import { User } from 'src/app/models/user.model';

import { environment } from 'src/environments/environment.prod';

import { PdfUtilities } from '../../../../utilities/pdf/pdf.utilities';
import { EmailTemplate } from '../../../../constants/email-template';
import { ManagementOrdersResult } from '../presenter/interfaces/management.result';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { IsRequestComplete } from '../../../../interfaces/isrequest-complete';
import { GlobalRequest } from '../../../../services/global/presenter/global.request';
import {
  ManagementOrdersRequest,
  RemovedInstallationRequest,
  RemovedServWorkRequest,
  RemovedTankRequest,
  UpdatedInstallationRequest,
  UpdatedServWorkRequest,
  UpdatedTankRequest
} from '../presenter/interfaces/management.request';
import { ManagementOrdersPresenter } from '../presenter/management.presenter';
import { GlobalPresenter } from '../../../../services/global/presenter/global.presenter';
import { getOrderTypeName } from '../../../../utilities/orders/get-order-type';
import { UserRolesEnum } from '../../../../constants/user-roles.enum';
import { CreateOrderModalComponent } from '../../../../shared/widgets/orders/create-order-modal/create-order-modal.component';
import { OrderInfoModalComponent } from '../../../../shared/widgets/orders/order-info-modal/order-info-modal.component';
import { CompleteOrderModalComponent } from '../../../../shared/widgets/orders/complete-order-modal/complete-order-modal.component';
import { EditTankOrderModalComponent } from '../../../../shared/widgets/orders/edit-tank-order-modal/edit-tank-order-modal.component';
import { EditInstallationOrderModalComponent } from '../../../../shared/widgets/orders/edit-installation-order-modal/edit-installation-order-modal.component';
import { DateFilterValue } from 'src/app/shared/widgets/document-viewer/components/date-filter/date-filter.component';
import { DialogsService } from '../../../../services/dialogs.service';
import { Router } from '@angular/router';
import { DeviceService } from '../../../../services/device/device.service';

// Tier 8: column-utils factory helpers replace the legacy CellMaker row-header
// templates and inline cellRenderers used in `initAgGrid`.
import {
  createActionColumn,
  createBadgeColumn,
  createPlainColumn,
  createTitlecaseColumn
} from '../../../../shared/components/kite-grid/column-utils/column-utils';

const base_url = environment.base_url;


export enum ViewMode {
  GRID = 'grid',
  CALENDAR = 'calendar'
}

@Component({
  selector: 'app-management-order',
  templateUrl: './management-order.component.html',
  styleUrls: ['./management-order.component.scss'],
  standalone: false
})
export class ManagementOrderComponent implements ManagementOrdersResult, IsRequestComplete, OnInit {

  // Tier 8: ViewChild('flex') setter/getter + `_flex: wjcGrid.FlexGrid` removed
  // — there is no longer any wj-flex-grid referenceable in this component.

  private requestGlobal: GlobalRequest;
  private request: ManagementOrdersRequest;
  private requestUpdateTank: UpdatedTankRequest;
  private requestRemoveTank: RemovedTankRequest;
  private requestUpdateServWork: UpdatedServWorkRequest;
  private requestRemoveServWork: RemovedServWorkRequest;
  private requestUpdateInstallation: UpdatedInstallationRequest;
  private requestRemoveInstallation: RemovedInstallationRequest;

  // Tier 8: `orders_arr_Tmp` / `orders_arr` / `pagination_arr` removed (only used
  // by the deleted _getData CollectionView wrappers). `orders` signal remains.
  order: any;
  columnDefs: any[] = [];
  gridOptions: any = {};
  readonly orders = signal<any[]>([]);
  worksreqsel_list: WorkReqSelModel[] = [];
  public usuario: User;
  ROLE = '';
  sale_person: string;
  sale_person_id: string;
  message: string = '';
  files_arr: File[] = [];
  files_arr_tmp: File[] = [];
  fileSubir: File;
  fileData: any = null
  installationForm: UntypedFormGroup;
  serviceWorkForm: UntypedFormGroup;
  tankForm: UntypedFormGroup;
  completeOrderForm: UntypedFormGroup;
  compOrderDisable: boolean = false;
  popupForm!: UntypedFormGroup;
  pdfUtilities: PdfUtilities = new PdfUtilities();
  pathFile: string = '';
  imgView: string = '';
  imgViewHide: boolean = false;
  pdf_arr: File[] = [];
  signatureHide: boolean = false;
  signaturePad: string = '';
  signaturePadOptions: Object = {
    'minWidth': 1,
    'canvasWidth': 350,
    'canvasHeight': 200,
  };

  totalRecords: number = 0;
  loading = signal(false);
  pageSize = 21;
  ViewMode = ViewMode;
  viewMode: ViewMode = ViewMode.GRID;

  toggleView(mode: ViewMode) {
    this.viewMode = mode;
  }

  filter_options = [
    { value: 'DUE', label: 'Due' },
    { value: 'TODAY', label: 'Today' },
    { value: 'ON TIME', label: 'On Time' },
    { value: 'ASSIGNED', label: 'Assigned' },
    { value: 'PARTIAL', label: 'Partial' },
    { value: 'DONE', label: 'Completed' }
  ];

  selected_values = [
    { value: 'DUE', label: 'Due' },
    { value: 'TODAY', label: 'Today' },
    { value: 'ON TIME', label: 'On Time' },
    { value: 'ASSIGNED', label: 'Assigned' },
    { value: 'PARTIAL', label: 'Partial' }
  ];

  // Tier 8: tplSettingBtn / tplInfoBtn / tplDeleteBtn CellMaker templates removed.

  constructor(private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private globalPresenter: GlobalPresenter,
    private managementOrdersPresenter: ManagementOrdersPresenter,
    private dialogsService: DialogsService,
    private router: Router,
    public deviceService: DeviceService,
  ) {
    this.requestGlobal = globalPresenter;
    globalPresenter.setComponent(this);
    this.request = managementOrdersPresenter;
    this.requestUpdateTank = managementOrdersPresenter;
    this.requestRemoveTank = managementOrdersPresenter;
    this.requestUpdateServWork = managementOrdersPresenter;
    this.requestRemoveServWork = managementOrdersPresenter;
    this.requestUpdateInstallation = managementOrdersPresenter;
    this.requestRemoveInstallation = managementOrdersPresenter;
    managementOrdersPresenter.setComponent(this);
    managementOrdersPresenter.setRequestCompleteComponent(this);
  }

  ngOnInit(): void {
    this.usuario = this.requestGlobal.getUser();
    this.ROLE = this.usuario.role;
    this.sale_person = this.ROLE == 'SALESPER_ROLE' ? this.usuario.name : 'NA';
    this.sale_person_id = this.ROLE == 'SALESPER_ROLE' ? this.usuario.uid : 'NA';

    // Default view mode override for tablet
    if (this.deviceService.isTablet()) {
      this.viewMode = ViewMode.CALENDAR;
    }

    this.initAgGrid();
    this.mainData();
    this.crearFormulario('');
  }

  readonly alertLevelOptions = [
    { code: 'Normal', name: 'Normal' },
    { code: 'Low', name: 'Low' },
    { code: 'Critical', name: 'Critical' },
  ];

  /**
   * Centraliza permisos de acceso: ADMIN_ROLE, SERVMAN_ROLE, IT_ROLE tienen acceso total.
   * Sales Person owner del cliente (sales_person_id) tiene acceso a sus propias órdenes.
   */
  hasAccessToOrder(order: any): boolean {
    if (!order) return false;
    const bypassRoles: string[] = [
      'ADMIN_ROLE',
      'SERVMAN_ROLE',
      UserRolesEnum.IT_ROLE,
      UserRolesEnum.SUPER_ADMIN_ROLE,
      UserRolesEnum.SERVICES_ROLE
    ];
    if (bypassRoles.includes(this.ROLE)) return true;
    if (order.sales_person_id && order.sales_person_id === this.usuario.uid) return true;
    return false;
  }

  // Tier 8: `info(flex, e)` / `edit(flex, e)` / `delete(flex, e)` / `complete(flex, e)`
  // removed — they were only invoked from the `*ngIf="false"` wj-flex-grid rows. The
  // active handlers are now `infoGridRow` / `deleteGridRow` / `completeGridRow`
  // routed through `(cellClicked)` from the wrapper.

  isRequestComplete(status: boolean, error?: HttpErrorResponse, data?: object | any[]): void {
    if (error) this.toastr.error(error.error.msg ?? 'Error');
  }
  getResponse(response: HttpResponse<any>): void {
    this.toastr.success(response['msg']);
    this.mainData();
    const model = response['installation'] ?? response['servwork'] ?? response['tank'];
    if (this.signaturePad !== '' && model) {
      this.handleEditResponse(model, response['msg']);
    }
  }

  private async handleEditResponse(model: any, msg: string): Promise<void> {
    const typeModel = msg.split(' ')[0];
    let pdf: PdfMakeWrapper | undefined = undefined;
    switch (typeModel) {
      case 'Installation':
        pdf = this.pdfUtilities.downloadPDFInstallationOrder(model);
        break;
      case 'ServiceWork':
        pdf = this.pdfUtilities.downloadPDFServWorkOrder(model);
        break;
      case 'Tank':
        pdf = this.pdfUtilities.downloadPDFTankOrder(model);
        break;
      default:
        break;
    }
    this.signaturePad = '';
    pdf?.create().download(`${model.ident_order}`);
    this.mainData();
  }

  async mainData() {
    await this.fetchOrders(1, this.pageSize);
  }

  async fetchOrders(page: number, limit: number) {
    this.loading.set(true);
    const statusStr = this.selected_values && this.selected_values.length > 0
      ? this.selected_values.map(v => v.value).join(',')
      : undefined;
    const ordersData: any = await this.request.getOrders(
      page, limit, this.filter.start, this.filter.end, this.filter.query, statusStr
    );
    const data = ordersData?.orders ?? [];
    this.totalRecords = ordersData?.total ?? 0;
    // Tier 8: pass the data directly to the wrapper (no CollectionView wrapping).
    this.orders.set(this.transformOrders(data));
    this.loading.set(false);
  }

  /** Tier 8: replaces `_getData(arr)` + CollectionView wrapping. */
  private transformOrders(arr: any[]): any[] {
    return arr.map((item: any) => ({
      ...item,
      start_date_f: this.formatDate(item.start_date, 'MM/dd/yyyy HH:mm tt')
    }));
  }

  onStatusFilter(options: any[]) {
    this.selected_values = options;
    this.fetchOrders(1, this.pageSize);
  }

  getStatusFilterString(): string {
    return this.selected_values && this.selected_values.length > 0
      ? this.selected_values.map(v => v.value).join(',')
      : '';
  }

  async loadMore(page: number, limit: number) {
    await this.fetchOrders(page, limit);
  }

  updateTotalRecords(total: number) {
    this.totalRecords = total;
  }

  drawComplete(signaturepad: LibSignaturePadComponent) {
    this.signaturePad = signaturepad.toDataURL();
  }

  drawStart() {
  }

  clearPad(signaturepad: LibSignaturePadComponent) {
    signaturepad.clear();
    this.signaturePad = '';
  }

  backSignature() {
    this.signatureHide = false;
    this.signaturePad = this.order.signature;
  }

  private crearFormulario(data: any) {
    switch (data?.type) {
      case 'TANK ORDER':
        this.openEditTankModal(data);
        break;
      case 'INSTALLATION':
        this.openEditInstallationModal(data);
        break;
      default:
        this.crearTankForm(null);
        this.crearServiceWorkForm(null);
        this.crearInstallationForm(null);
        break;
    }
  }

  openEditTankModal(orderData: any): void {
    this.order = orderData;
    const modalRef = this.modalService.open(EditTankOrderModalComponent, {
      size: 'xl',
      centered: true
    });
    modalRef.componentInstance.order = orderData;
    modalRef.componentInstance.orderUpdated.subscribe((result: any) => {
      this.requestUpdateTank.editTank({ ...result.formValue, _id: result.orderId });
    });
  }

  openEditInstallationModal(orderData: any): void {
    this.order = orderData;
    const modalRef = this.modalService.open(EditInstallationOrderModalComponent, {
      size: 'xl',
      centered: true
    });
    modalRef.componentInstance.order = orderData;
    modalRef.componentInstance.orderUpdated.subscribe((result: any) => {
      this.requestUpdateInstallation.editInstallation({ ...result.formValue, _id: result.orderId });
    });
  }

  crearTankForm(data: any) {
    this.tankForm = this.fb.group({
      name_tank: [data ? data.name_tank : ''],
      start_date: [data ? data.start_date : ''],
      size: [data ? data.size : ''],
      width: [data ? data.width : ''],
      height: [data ? data.height : ''],
      deepth: [data ? data.deepth : ''],
      units: [data ? data.units : ''],
      priority: [data ? data.priority : ''],
      security_type: [data ? data.security_type : ''],
      pump: [data ? data.pump : ''],
      grid: [data ? data.grid : ''],
      nozzle: [data ? data.nozzle : ''],
      comments: [data ? data.comments : ''],
      project: [data ? data.project : ''],
      id_tank: [data ? data.ident_order : ''],
      name_tank_address: [data ? data.name_client_address : ''],
    });
  }

  crearInstallationForm(data: any) {
    this.installationForm = this.fb.group({
      name_installation: [data ? data.name_installation : ''],
      name_installation_address: [data ? data.name_client_address : ''],
      id_install: [data ? data.ident_order : ''],
      start_date: [data ? data.start_date : ''],
      contact_name: [data ? data.contact_name : ''],
      email: [data ? data.email : ''],
      phone: [data ? data.phone : ''],
      installer_name: [data ? data.installer_name : ''],
      tank_size: [data ? data.tank_size : ''],
      tank_width: [data ? data.tank_width : ''],
      tank_height: [data ? data.tank_height : ''],
      tank_deepth: [data ? data.tank_deepth : ''],
      tank_pump: [data ? data.tank_pump : ''],
      priority: [data ? data.priority : ''],
      request_overview: [data ? data.request_overview : ''],
      project: [data ? data.project : ''],
      tank: [data ? data.tank : false],
      pump: [data ? data.pump : false],
      filter: [data ? data.filter : false],
      training: [data ? data.training : false],
    });
  }

  crearServiceWorkForm(data: any) {
    const dateFlag = data?.date_issued ? true : false;
    this.serviceWorkForm = this.fb.group({
      name_servwork: [data ? data.name_servwork : ''],
      name_service_address: [data ? data.name_client_address : ''],
      start_date: [data ? data.start_date : ''],
      contact_name: [data ? data.contact_name : ''],
      email: [data ? data.email : ''],
      phone: [data ? data.phone : ''],
      date_issued: [dateFlag ? new Date(data.date_issued).toISOString().split('T')[0] : ''],
      work_request: [data ? data.work_request : ''],
      request_overview: [data ? data.request_overview : ''],
      project: [data ? data.project : ''],
      id_service: [data ? data.ident_order : ''],
      alert_level: [data ? data.alert_level : 'Normal'],
    });
  }

  get startServiceSelectNoValido() {
    return this.completeOrderForm.get('start_service')?.invalid && this.completeOrderForm.get('start_service')?.touched;
  }
  get endServiceSelectNoValido() {
    return this.completeOrderForm.get('end_service')?.invalid && this.completeOrderForm.get('end_service')?.touched;
  }
  get approvedclientnameNoValido() {
    return this.completeOrderForm.get('approved_client_name')?.invalid && this.completeOrderForm.get('approved_client_name')?.touched;
  }

  crearCompleteOrderForm(data: any) {
    this.signaturePad = data ? data.signature : '';
    const performedby_Flag = data?.work_performed_by ? true : false;
    this.completeOrderForm = this.fb.group({
      _id: [data ? data._id : ''],
      ident_order: [data ? data.ident_order : ''],
      start_service: [data ? data.start_service : '', [Validators.required, Validators.minLength(1)]],
      end_service: [data ? data.end_service : '', [Validators.required, Validators.minLength(1)]],
      work_performed_by: [performedby_Flag ? data.work_performed_by : ''],
      completed_service: [data ? data.completed_service : ''],
      approved_client_name: [data ? data.approved_client_name : '', [Validators.required, Validators.minLength(1)]],
      description_work: [data ? data.description_work : ''],
      signature: [data ? data.signature : ''],
      my_signature: [this.usuario.signature ? this.usuario.signature : ''],
      status: [data ? data.status : ''],
    });
  }

  editTank(popup: any) {
    this.requestUpdateTank.editTank({ ...this.tankForm.value, _id: this.order._id });
    popup.hide();
  }
  editInstallation(popup: any) {
    this.requestUpdateInstallation.editInstallation({ ...this.installationForm.value, _id: this.order._id });
    popup.hide();
  }
  editServiceWork(popup: any) {
    this.requestUpdateServWork.editServWork({ ...this.serviceWorkForm.value, _id: this.order._id });
    popup.hide();
  }

  editCompleteOrder(modal: any) {
    this.pdf_arr = [];
    if (this.completeOrderForm.get('my_signature')?.value == '') {
      return this.toastr.error('User Signature missing');
    }
    if (this.signaturePad == '' || !this.signaturePad) {
      return this.toastr.error('Client Signature missing');
    }
    if (this.completeOrderForm.invalid) {
      return Object.values(this.completeOrderForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }
    if (this.signatureHide || !this.completeOrderForm?.get('signature')?.value) {
      this.completeOrderForm.get('signature')?.setValue(this.signaturePad);
    }
    this.completeOrderForm.get('status')?.setValue('CLOSE');

    const _arr: any = [];
    this.files_arr.forEach(item => {
      _arr.push(item.name);
    });

    modal.close();
    switch (this.order.type) {
      case 'TANK ORDER':
        this.updateTank();
        break;
      case 'INSTALLATION':
        this.updateInstallation();
        break;
      case 'WORK ORDER':
        this.updateServWork();
        break;
      default:
        break;
    }
  }

  private updateTank() {
    this.requestUpdateTank.editTank({ ...this.completeOrderForm.value, _id: this.order._id });
  }
  private updateInstallation() {
    this.requestUpdateInstallation.editInstallation({ ...this.completeOrderForm.value, _id: this.order._id });
  }
  private updateServWork() {
    this.requestUpdateServWork.editServWork({ ...this.completeOrderForm.value, _id: this.order._id });
  }

  private toSendPDF(pdf: PdfMakeWrapper, _fileName: string): void {
    const pdfDocGenerator = pdf.create();
    pdfDocGenerator.getBlob((document: any) => {
      const file = new File([document], `${_fileName}.pdf`, {
        type: 'application/pdf',
      });
      this.pdf_arr.push(file);
      this.setEmailData();
    });
  }

  async setEmailData() {
    const _emails: any = [];
    const users = await this.requestGlobal?.getUserList();
    users?.forEach((user: any) => {
      if (user.role === 'INSLLTEAM_ROLE' || user.role === 'LOGICOR_ROLE') {
        _emails.push(user.email);
      }
    });
    this.sendingEmail(_emails.join());
  }

  private sendingEmail(_emails: string): void {
    const json = {
      email: _emails,
      bodyHtml: EmailTemplate.HTML_BODY_ORDER('Tank Order'),
      attachment: _emails
    };
    this.requestGlobal?.sentEmail(_emails, json.bodyHtml, this.files_arr);
  }


  deleteOrder(order: any) {
    switch (order.type) {
      case 'TANK ORDER':
        this.deleteTank(order);
        break;
      case 'INSTALLATION':
        this.deleteInstallation(order);
        break;
      case 'WORK ORDER':
        this.deleteServiceWork(order);
        break;
      default:
        this.deleteTank(order);
        this.deleteInstallation(order);
        this.deleteServiceWork(order);
        break;
    }
  }

  deleteTank(order: any) {
    this.requestRemoveTank.deleteTank(order._id);
  }
  deleteInstallation(order: any) {
    this.requestRemoveInstallation.deleteInstallation(order._id);
  }
  deleteServiceWork(order: any) {
    this.requestRemoveServWork.deleteServWork(order._id);
  }

  async getPDF_File_Download(id: string, fileName: string) {
    const type = getOrderTypeName(fileName.split('-')[0]);
    const file = await this.requestGlobal?.downloadFile(type, id, fileName);
    window.open(URL.createObjectURL(file), '_blank');
  }

  setFile(_file: File) {
    if (_file) {
      const nombreCortado = _file.name.split('.');
      const extensionArchivo = nombreCortado[nombreCortado.length - 1];
      const code = new Date().getMilliseconds();
      const nombreArchivo = `${this.order.ident_order}-${code}.${extensionArchivo}`;
      const extensionesValida = ['png', 'jpg', 'jpeg', 'gif'];

      if (!extensionesValida.includes(extensionArchivo)) {
        return this.toastr.error(`${extensionArchivo} no valid`);
      }

      const newfile = new File([_file], nombreArchivo, {
        type: _file.type,
      });

      this.files_arr_tmp.push(newfile);
    } else {
      return this.toastr.error(`No file selected`);
    }
  }

  removeFile(_file: File) {
    this.files_arr_tmp = this.files_arr_tmp.filter(item => item != _file);
    this.files_arr = [... this.files_arr_tmp];
  }

  showFiles() {
    const _input = <HTMLInputElement>document.getElementById('inputfile');
    _input.value = '';
    this.files_arr = [... this.files_arr_tmp];
  }

  previewImgFile(_file: File | null) {
    if (!_file) {
      return this.fileData = null;
    }
    const reader = new FileReader();
    reader.readAsDataURL(_file);
    reader.onloadend = () => {
      this.fileData = reader.result;
    };
  }

  getFile(_file: File) {
    this.fileData = null;
    this.imgView = _file.name;
    this.imgViewHide = true;
    this.pathFile = `${base_url}/upload/orders/${_file.name}`;
    if (_file.size > 10) {
      this.previewImgFile(_file);
    }
  }

  closeImgView() {
    this.imgView = '';
    this.imgViewHide = false;
    this.fileData = null;
  }

  async uploadFile(_order: any) {
    const _arr: any = [];
    this.files_arr.forEach((file: any) => {
      const matches = this.order.files.filter((element: string) => {
        if (element.indexOf(file.name) !== -1) {
          return true;
        }
      });
      if (matches.length == 0) {
        _arr.push(file);
      }
    });
    for (const _fileSubir of _arr) {
      await this.requestGlobal?.uploadFile(_fileSubir, 'orders', _order._id, false);
      this.removeFile(_fileSubir);
    }
  }

  open(content: TemplateRef<NgbModal>, size: string, data: any): void {
    this.order = data;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, scrollable: true });
  }

  openInfoModal(orderData: any, startInEditMode: boolean = false): void {
    if (this.deviceService.isTablet()) {
      this.router.navigate(['/uco/manage-order/edit', orderData._id]);
      return;
    }

    const modalRef = this.modalService.open(OrderInfoModalComponent, {
      size: 'xl',
      centered: true,
      scrollable: true
    });

    const ref = modalRef as any;
    const componentRef = ref.componentRef || ref._contentRef?.componentRef;

    if (componentRef) {
      componentRef.setInput('ident_order', orderData._id);
      componentRef.setInput('startInEditMode', startInEditMode);
    } else {
      modalRef.componentInstance.ident_order = orderData._id;
      modalRef.componentInstance.startInEditMode = startInEditMode;
    }

    modalRef.result.then((result: any) => {
      if (result?.action === 'download') {
        this.getPDF_File_Download(result.orderId, result.fileName);
      }
      if (result?.action === 'refresh') {
        this.mainData();
      }
    }).catch(() => { });
  }

  openCompleteOrderModalNew(orderData: any): void {
    this.order = orderData;

    if (this.deviceService.isTablet() || this.ROLE === UserRolesEnum.SERVICES_ROLE) {
      this.router.navigate(['/uco/manage-order/complete', orderData._id]);
      return;
    }

    const modalRef = this.modalService.open(CompleteOrderModalComponent, {
      size: 'xl',
      centered: true
    });

    const ref = modalRef as any;
    const componentRef = ref.componentRef || ref._contentRef?.componentRef;

    if (componentRef) {
      componentRef.setInput('ident_order', orderData._id);
      componentRef.setInput('userSignature', this.usuario?.signature || '');
    } else {
      modalRef.componentInstance.ident_order = orderData._id;
      modalRef.componentInstance.userSignature = this.usuario?.signature || '';
    }
    modalRef.result.then((result: any) => {
      if (result === true) {
        this.mainData();
      }
    }).catch(() => { });
  }

  openDeleteConfirmation(orderData: any): void {
    this.order = orderData;
    this.dialogsService.openConfirmationModal({
      title: 'Delete Order',
      msg: `Do you want to Delete the Order ${orderData.ident_order} associated to ${orderData.name_client_address}?`,
      confirmText: 'Yes, Delete it!',
      onConfirm: () => this.deleteOrder(orderData)
    });
  }

  openCompleteOrderModal(content: TemplateRef<NgbModal>, size: string, data: any): void {
    this.order = data;
    this.files_arr_tmp = [];
    this.files_arr = [];
    if (this.order.files?.length > 0) {
      this.order.files.forEach((item: string) => {
        const file = new File(['foo'], item, { type: 'text/plain' });
        this.files_arr_tmp.push(file);
        this.files_arr.push(file);
      });
    }
    this.compOrderDisable = this.order.status == 'CLOSE' ? true : false;
    this.signatureHide = false;
    this.imgViewHide = false;
    this.crearCompleteOrderForm(this.order);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: size });
  }
  exporting: boolean = false;

  exportExcelFile() {
    this.exporting = true;

    let startDate: any = undefined;
    let endDate: any = undefined;
    if (this.filter.start) {
      startDate = new Date(this.filter.start).toISOString();
    }
    if (this.filter.end) {
      endDate = new Date(this.filter.end).toISOString();
    }

    const statusStr = this.selected_values && this.selected_values.length > 0
      ? this.selected_values.map(v => v.value).join(',')
      : undefined;

    this.managementOrdersPresenter.exportOrdersExcel(startDate, endDate, this.filter.query, statusStr).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const estTime = new Date(new Date().getTime() - (5 * 60 * 60 * 1000));
        const formattedDate = estTime.toISOString().split('T')[0];
        const filename = `OrderList_${formattedDate}.xlsx`;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        this.exporting = false;
        this.toastr.success('Excel downloaded successfully');
      },
      error: () => {
        this.exporting = false;
        this.toastr.error('Error generating Excel');
      }
    });
  }

  // Tier 8: `setAllData()` / `setDataRange()` / `_getDataByRange()` removed —
  // their only callers were Wijmo-specific flows; the AG Grid path uses `fetchOrders`
  // + `onDateFilterChange` + `onStatusFilter` instead.

  filter: any = {};

  onDateFilterChange(value: DateFilterValue) {
    if (value.type === 'none') {
      this.filter.start = undefined;
      this.filter.end = undefined;
    } else {
      this.filter.start = value.startDate;
      this.filter.end = value.endDate;
    }
    this.loadMore(1, this.pageSize);
  }

  /** Tier 8: replaces `wijmo.Globalize.format(new Date(date), format)`.
   *  Uses native `Intl.DateTimeFormat` to support the formats observed across
   *  this file (`MM/dd/yyyy`, `MM/dd/yyyy HH:mm`, `MM/dd/yyyy HH:mm tt`). */
  formatDate(date: any, format: string): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
    const hh12 = String(d.getHours() % 12 || 12).padStart(2, '0');
    switch (format) {
      case 'MM/dd/yyyy':
        return `${mm}/${dd}/${yyyy}`;
      case 'MM/dd/yyyy HH:mm tt':
        return `${mm}/${dd}/${yyyy} ${hh12}:${mi} ${ampm}`;
      case 'MM/dd/yyyy HH:mm':
        return `${mm}/${dd}/${yyyy} ${hh}:${mi}`;
      case 'MM/dd/yyy':
        return `${mm}/${dd}/${yyyy}`;
      default:
        return `${mm}/${dd}/${yyyy}`;
    }
  }

  private formatDateTime(date: string): string {
    if (!date) return '';
    const parsedDate = new Date(date);
    const day = parsedDate.getUTCDate().toString().padStart(2, '0');
    const month = (parsedDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = parsedDate.getUTCFullYear();
    const hours = parsedDate.getUTCHours().toString().padStart(2, '0');
    const minutes = parsedDate.getUTCMinutes().toString().padStart(2, '0');
    const seconds = parsedDate.getUTCSeconds().toString().padStart(2, '0');
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }

  /** Tier 8: replaces `_setupGrid(grid)` (legacy wijmo formatItem handler) and
   *  `formatCell(cell, item, col)` (legacy inline HTML renderer). The AG Grid
   *  badge column uses the same predicates.
   *
   *  Priority: Workflow states (CLOSE > PARTIAL > Assigned) always override
   *  temporal semaphore. Time-based labels (TODAY / DUE / ON TIME) apply only
   *  to unassigned orders (New / Unassigned status). */
  getStatusBadgeConfig(item: any) {
    const now = new Date();
    const startDate = new Date(item.start_date);

    // 1. Workflow states — maximum priority, independent of date
    if (item.status === 'CLOSE') {
      return { text: 'COMPLETED', dotClass: 'dot-complete' };
    }
    if (item.status === 'PARTIAL') {
      return { text: 'PARTIAL', dotClass: 'dot-partial' };
    }
    if (item.status === 'Assigned') {
      return { text: 'ASSIGNED', dotClass: 'dot-assigned' };
    }

    // 2. Temporal semaphore — only for unassigned orders (New / Unassigned)
    if (this.isSameDateAs(startDate, now)) {
      return { text: 'TODAY', dotClass: 'dot-warning' };
    }
    if (startDate.getTime() < now.getTime()) {
      return { text: 'DUE', dotClass: 'dot-no-complete' };
    }
    return { text: 'ON TIME', dotClass: 'dot-info' };
  }

  private isSameDateAs(dDate: Date, pDate: Date): boolean {
    return (
      dDate.getFullYear() === pDate.getFullYear() &&
      dDate.getMonth() === pDate.getMonth() &&
      dDate.getDate() === pDate.getDate()
    );
  }

  openCreateOrder() {
    this.router.navigate(['/uco/create-order']);
  }

  onTabletSearch(term: string) {
    this.filter.query = term;
    this.loadMore(1, this.pageSize);
  }

  refreshData(page: number) {
    this.loadMore(page, this.pageSize);
  }

  initAgGrid(): void {
    this.columnDefs = [
      // Tier 8: replaced 130 lines of inline cellRenderer + onCellClicked with
      // createActionColumn() (ActionButtonsCellRendererComponent under the hood).
      createActionColumn({
        width: 120,
        buttons: [
          { icon: 'fa-eye', title: 'View info', ariaLabel: 'view info', classes: 'info-btn' },
          ...(this.usuario?.hasPermission?.('orders', 'delete')
            ? [{ icon: 'fa-trash', title: 'Delete', ariaLabel: 'Delete', classes: 'delete-btn' }]
            : []),
          {
            icon: 'fa-cog',
            title: 'Process order',
            ariaLabel: 'Process order',
            classes: 'complete-btn',
            // Disables when the order is already closed (status === 'CLOSE').
            disabled: (item: any) => item?.status === 'CLOSE'
          }
        ]
      }),
      createPlainColumn({
        field: 'ident_order',
        headerName: 'Order ID',
        width: 120,
        cellClass: 'ag-cell-center'
      }),
      createTitlecaseColumn({
        field: 'name_client_address',
        headerName: 'Client Name',
        flex: 1,
        minWidth: 200,
        cellClass: 'ag-cell-left'
      }),
      createPlainColumn({
        field: 'type',
        headerName: 'Order Type',
        width: 160,
        cellClass: 'ag-cell-center'
      }),
      createPlainColumn({
        field: 'start_date_f',
        headerName: 'Due Date',
        width: 200,
        cellClass: 'ag-cell-center'
      }),
      // Tier 8: alert_label badge column uses createBadgeColumn + getStatusBadgeConfig
      // predicates. Replaces the inline HTML renderer that lived in initAgGrid.
      createBadgeColumn({
        field: 'alert_level',
        headerName: 'Alert Label',
        width: 160,
        dotClass: (item: any) => this.getStatusBadgeConfig(item).dotClass,
        text: (item: any) => this.getStatusBadgeConfig(item).text
      }),
      {
        // Inline because tank_size must render for all order types, not just INSTALLATION.
        field: 'tank_size',
        headerName: 'Tank Size',
        width: 90,
        cellClass: 'ag-cell-center',
        valueFormatter: (p: any) => {
          return (p.value != null && p.value !== '' && Number(p.value) !== 0)
            ? p.value
            : '—';
        }
      } as any
    ];

    this.gridOptions = {
      onCellClicked: (event: any) => {
        const target = event?.event?.target as HTMLElement | undefined;
        const button = target?.closest('button');
        if (button) {
          const row = event.data;
          if (!row) return;
          if (button.classList.contains('info-btn')) {
            this.infoGridRow(row);
          } else if (button.classList.contains('delete-btn')) {
            this.deleteGridRow(row);
          } else if (button.classList.contains('complete-btn')) {
            this.completeGridRow(row);
          }
          return;
        }

        const row = event?.data;
        if (row?._id) {
          this.infoGridRow(row);
        }
      }
    };
  }

  infoGridRow(order: any) {
    if (!this.hasAccessToOrder(order)) {
      return this.toastr.warning('No valid selection');
    }
    this.openInfoModal(order);
  }

  deleteGridRow(order: any) {
    this.openDeleteConfirmation(order);
  }

  completeGridRow(order: any) {
    if (!this.hasAccessToOrder(order)) {
      return this.toastr.warning('No valid selection');
    }
    if (order?.status === 'CLOSE') {
      this.dialogsService.openFeedbackWarning({
        title: 'Order Already Completed',
        msg: 'This service order has already been completed and closed. It cannot be processed again.'
      });
      return;
    }
    this.openCompleteOrderModalNew(order);
  }
}
